enum ActivityRemindType {
  EMAIL = "email",
  PUSH = "push",
}

export default ActivityRemindType;
